import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, EditableDBItemV3 } from '@nu-art/thunderstorm-frontend';
import { md5, resolveContent } from '@nu-art/ts-common';
//poner el item id en extends
export function createWorkHubManager(config) {
    class WorkHubManager extends ComponentSync {
        getEditable(item) {
            return new EditableDBItemV3(item, config.module)
                .setAutoSave(!!item._id)
                .setDebounceTimeout(300)
                .setOnChanged(async () => this.forceUpdate())
                .setOnSaveCompleted((savedItem) => {
                if (item._id === savedItem._id)
                    return;
                const newTabId = md5(`${config.dbDef.dbKey}-${savedItem._id}`);
                const label = config.labelResolver(savedItem);
                this.props.workHubItem.openTab(newTabId, label, {
                    ...this.state.renderArgs,
                    itemId: savedItem._id,
                    editMode: false,
                });
                this.props.workHubItem.closeTab(this.state.tabId);
            });
        }
        deriveStateFromProps(nextProps, state) {
            state.tabId = nextProps.tabId;
            state.renderArgs = nextProps.renderArgs;
            if (state.renderArgs.readonly)
                state.renderArgs = { ...state.renderArgs, editMode: false };
            const entity = (config.module).cache.unique(state.renderArgs.itemId);
            state.editable ??= this.getEditable(entity ?? resolveContent(config.defaultItem));
            return state;
        }
        render() {
            if (!this.state.editable)
                return _jsx(_Fragment, {});
            const Editor = config.EditorComponent;
            return _jsx(Editor, { workHubItem: this.props.workHubItem, renderArgs: this.state.renderArgs, editable: this.state.editable, tabId: this.state.tabId });
        }
    }
    const WorkHubManagerWrapper = (props) => (_jsx(WorkHubManager, { ...props }, props.tabId));
    return WorkHubManagerWrapper;
}
//# sourceMappingURL=workhub-manager-factory.js.map